import React, { useMemo } from "react";
import feel1 from "../img/feelLikeALocalWhereverYouGo/feel1.png";
import feel2 from "../img/feelLikeALocalWhereverYouGo/feel2.png";
import feel3 from "../img/feelLikeALocalWhereverYouGo/feel3.png";
import feel4 from "../img/feelLikeALocalWhereverYouGo/feel4.png";
import Model from "@tripian/model";

// CanadaStrong swaps "Personalized Recommendations" and "Best Places & Features"
// for two client-specific features.
const featureData = [
  {
    titleKey: "landing.feelLikeALocalWhereverYouGo.smartAiItineraries.title",
    descriptionKey:
      "landing.feelLikeALocalWhereverYouGo.smartAiItineraries.description",
    image: feel1,
  },
  {
    titleKey:
      "landing.feelLikeALocalWhereverYouGo.mappedOutDailyItineraries.title",
    descriptionKey:
      "landing.feelLikeALocalWhereverYouGo.mappedOutDailyItineraries.description",
    image: feel2,
  },
  {
    titleKey: "landing.feelLikeALocalWhereverYouGo.accessAnywhereAnytime.title",
    descriptionKey:
      "landing.feelLikeALocalWhereverYouGo.accessAnywhereAnytime.description",
    image: feel3,
  },
  {
    titleKey: "landing.feelLikeALocalWhereverYouGo.climateFriendlyTravel.title",
    descriptionKey:
      "landing.feelLikeALocalWhereverYouGo.climateFriendlyTravel.description",
    image: feel4,
  },
];

type Props = {
  t: (value: Model.TranslationKey) => string;
};

const Benefits: React.FC<Props> = ({ t }) => {
  const features = useMemo(
    () =>
      featureData.map(item => ({
        title: t(item.titleKey as Model.TranslationKey),
        description: t(item.descriptionKey as Model.TranslationKey),
        image: item.image,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <section className="py-32 px-6 bg-white">
      <div className="text-center mb-16">
        <div className="w-full flex flex-col justify-center items-center gap-2 mb-8 md:mb-4">
          <p className="text-[#1434CB] font-inter text-lg md:text-2xl font-semibold md:tracking-widest uppercase text-center">
            {t("landing.keyFeatures")}
          </p>
          <div className="w-12 h-[0.05rem] bg-[#1434CB]" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mt-6">
          {t("landing.feelLikeALocalWhereverYouGo.title")}
        </h2>
      </div>

      <div className="max-w-5xl mx-auto flex flex-col gap-28">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row items-center gap-12 md:gap-32 ${index % 2 !== 0 ? "" : "md:flex-row-reverse"}`}
          >
            <div className="w-full md:w-1/2 grid justify-items-center md:justify-items-start">
              <img
                src={feature.image}
                alt={feature.title}
                className="w-40 md:w-80 h-auto"
              />
            </div>
            <div className="w-full md:w-1/2 text-center md:text-start">
              <h3 className="text-2xl md:text-4xl/[3.25rem] text-neutral-900 font-semibold mb-4">
                {feature.title}
              </h3>
              <p className="text-2xl/[2.5rem] font-normal text-zinc-500">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;
